import React from 'react'
import { Page } from 'src/shared'
import './notFound.scss'

export default () => (
  <Page className="not-found" title="Page not found">
    <div className="not-found__container">
      <h2>
        Woah! Couldn't find <i>that!</i>
      </h2>
      <p>
        We're not sure what you were looking for, <br />
        but it's not here!
      </p>
    </div>
  </Page>
)
